// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const params = {
  objectPath: __t.string(),
  colorPrimary: __t.string(),
  colorSecondary: __t.string(),
  colorTertiary: __t.string(),
  colorText: __t.string(),
  browsable: __t.bool(),
};
export const returnType = __t.string()